import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";
import { useRoutes, useLocation } from "react-router-dom";
// import "./App.css";
import { RTL } from "./layout/fullLayout/customizer/RTL";
import { ThemeSettings } from "./layout/fullLayout/customizer/ThemeSettings";
import { IStoreState } from "./redux/initialStoreState";
import { Router } from "./router/router";
import { useDispatchWrapper } from "./hooks";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DataTableV2Provider } from "./components/TableV2/context/DataTableV2Provider";
import { WhatsAppStatusProvider } from "./contexts/WhatsAppStatusProvider";
import { abortAllPendingRequests } from "./api/api";

function App() {
  const routing = useRoutes(Router);
  const location = useLocation();
  const theme = ThemeSettings();
  const dispatch = useDispatchWrapper();
  const customizer = useSelector(
    (state: IStoreState) => state.customizerReducer
  );

  React.useEffect(() => {
    abortAllPendingRequests();
  }, [location.pathname]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <RTL direction={customizer.activeDir as "ltr"}>
          <DataTableV2Provider cachingFilters={{ enableCaching: true }}>
            <WhatsAppStatusProvider>
              <CssBaseline />
              {routing}
            </WhatsAppStatusProvider>
          </DataTableV2Provider>
        </RTL>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
